export interface Token {
  id: string
  symbol: string
  name: string
  icon: string
  balance: string
  usdValue: string
}

export const mockTokens: Token[] = [
  {
    id: '1',
    symbol: 'BTC',
    name: 'Bitcoin',
    icon: 'https://assets.coingecko.com/coins/images/1/large/bitcoin.png',
    balance: '0.273656',
    usdValue: '$12,342.67',
  },
  {
    id: '2',
    symbol: 'USDT',
    name: 'Tether',
    icon: 'https://assets.coingecko.com/coins/images/325/large/Tether.png',
    balance: '245.00',
    usdValue: '$245.00',
  },
  {
    id: '3',
    symbol: 'USDC',
    name: 'USD Coin',
    icon: 'https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png',
    balance: '6,765.45',
    usdValue: '$6,765.00',
  },
  {
    id: '4',
    symbol: 'BNB',
    name: 'BNB',
    icon: 'https://assets.coingecko.com/coins/images/825/large/bnb-icon2_2x.png',
    balance: '53.39',
    usdValue: '$12,342.67',
  },
  {
    id: '5',
    symbol: 'ETH',
    name: 'Ethereum',
    icon: 'https://assets.coingecko.com/coins/images/279/large/ethereum.png',
    balance: '0.456723',
    usdValue: '$2,342.67',
  },
  {
    id: '6',
    symbol: 'SOL',
    name: 'Solana',
    icon: 'https://assets.coingecko.com/coins/images/4128/large/solana.png',
    balance: '3.55',
    usdValue: '$2,342.67',
  },
]